import type { ComponentProps } from 'react';
import { CounterClockwiseClockIcon, Cross2Icon, TrashIcon } from '@radix-ui/react-icons';
import type { ReviewAnnotationPanel } from './ReviewAnnotationPanel';
import './studio-annotation-toolbar.css';

/** Shared workspace header replacement; all annotation actions stay in one compact row. */
export function ClassroomAnnotationToolbar({
  tool,
  color,
  width,
  annotationCount,
  onTool,
  onColor,
  onWidth,
  onUndo,
  onClear,
  onClose,
}: ComponentProps<typeof ReviewAnnotationPanel>) {
  return (
    <aside className="studio-annotation-toolbar" role="toolbar" aria-label="添加标记">
      <div className="studio-annotation-scroll">
        {(
          [
            ['BRUSH', '🖌', '画笔'],
            ['LETTER', 'AB', '字母'],
            ['TRIANGLE', '△', '三角'],
            ['CIRCLE', '〇', '圆圈'],
            ['CROSS', '×', '叉号'],
          ] as const
        ).map(([nextTool, icon, label]) => (
          <button
            type="button"
            key={nextTool}
            title={label}
            aria-label={label}
            aria-pressed={tool === nextTool}
            onClick={() => onTool(nextTool)}
          >
            {icon}
          </button>
        ))}
        <span className="studio-annotation-divider" aria-hidden="true" />
        {(['RED', 'BLUE'] as const).map((nextColor) => (
          <button
            type="button"
            key={nextColor}
            className={`studio-annotation-color is-${nextColor.toLowerCase()}`}
            title={nextColor === 'RED' ? '红色' : '蓝色'}
            aria-label={nextColor === 'RED' ? '红色' : '蓝色'}
            aria-pressed={color === nextColor}
            onClick={() => onColor(nextColor)}
          >
            <span aria-hidden="true" />
          </button>
        ))}
        <select
          aria-label="画笔粗细"
          title="画笔粗细"
          value={width}
          disabled={tool !== 'BRUSH'}
          onChange={(event) => onWidth(Number(event.currentTarget.value))}
        >
          {[3, 5, 7, 9, 11, 13, 15].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <button
          type="button"
          title="撤销标记"
          aria-label="撤销标记"
          disabled={annotationCount === 0}
          onClick={onUndo}
        >
          <CounterClockwiseClockIcon aria-hidden="true" />
        </button>
        <button
          type="button"
          title="清空标记"
          aria-label="清空标记"
          disabled={annotationCount === 0}
          onClick={onClear}
        >
          <TrashIcon aria-hidden="true" />
        </button>
      </div>
      <button
        className="studio-annotation-close"
        type="button"
        title="关闭添加标记"
        aria-label="关闭添加标记窗口"
        onClick={onClose}
      >
        <Cross2Icon aria-hidden="true" />
      </button>
    </aside>
  );
}
